import React from 'react'
import I18n from 'i18n-react'

import String from './fields/String'

const FormBackoffice = (props) => (
  <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center">
    <div className="col-12 col-lg-4 order-0 order-sm-0 text-lg-right">
      <label className="mb-0 font-weight-bold" htmlFor="finalDestination">
        {I18n.translate(`vehicleInfoGeneral.fields.rz.label${props.isBackOffice ? 'Bo' : ''}`)}
        <span className="text-danger">*</span>
      </label>
    </div>
    <div className="col-12 col-lg-8 order-3 order-sm-0 my-2 pr-md-0 pr-sm-0">
      <div className={`row mr-1 ${props.rzOrVinRequired && !props.pushIsPristine ? 'is-invalid' : ''}`}>
        <div className="col-12 col-sm-4 col-lg-3 order-3 order-sm-0 my-2 pr-md-0 pr-sm-0">
          <div>
            <div className="d-inline-block w-100">
              <div className="form-group mb-0 d-flex flex-wrap align-items-center">
                <String
                  className="form-control mw-auto"
                  id="modalRZ"
                  isPristine={props.pushIsPristine}
                  name="modalRZ"
                  onBlur={props.handleOnBlur}
                  onChange={props.handleChange}
                  onErrorChange={props.handleChangeValidationError}
                  placeholder={I18n.translate(`vehicleInfoGeneral.fields.rz.placeholder`)}
                  ref={props.modalRz}
                  required={false}
                  validationErrors={props.combinedValidationErrors}
                  value={props.data.modalRZ}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-2 col-lg-1 order-3 order-sm-0 text-center d-flex align-items-center justify-content-center">
          <span>{I18n.translate('vehicleInfoGeneral.or')}</span>
        </div>
        <div className="col-12 col-sm-6 col-lg-5 order-3 order-sm-0 my-2 pr-md-0 pl-sm-0">
          <div>
            <div className="d-inline-block w-100">
              <div className="form-group mb-0 d-flex flex-wrap align-items-center">
                <String
                  className="form-control  mw-auto"
                  id="modalVIN"
                  isPristine={props.pushIsPristine}
                  maxLength={17}
                  name="modalVIN"
                  onBlur={props.handleOnBlur}
                  onChange={props.handleChange}
                  onErrorChange={props.handleChangeValidationError}
                  placeholder={I18n.translate(`vehicleInfoGeneral.fields.vin.placeholder`)}
                  ref={props.modalVin}
                  required={!props.data.modalRZ}
                  validationErrors={{}}
                  value={props.data.modalVIN}
                />
              </div>
            </div>
          </div>
        </div>
        {props.rzOrVinRequired && !props.pushIsPristine && (
          <div className="invalid-tooltip mt-0">
            <span>{I18n.translate('vehicleInfoGeneral.validationErrors.RZ_VIN')}</span>
          </div>
        )}
        {props.isBackOffice && (
          <div className="col-12 col-lg-2 order-4 order-sm-0 my-2 pr-md-0 pl-sm-0">
            <button className="btn btn-dark px-1" onClick={props.handleSubmit} tabIndex="2" type="submit">
              {I18n.translate(`${props.view}.button.loadBo`)}
            </button>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default FormBackoffice
